import { Button, DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutEdiDelayCodePartners extends Layout {
    buttonDisableAll: Button;
    buttonEnableAll: Button;
    labelHeader: Label;
    sourceEdiDelayCodeQualifiers: DataSource;
    tablePartnerQualifiers: Table;
}
